<template>
    <div class="card position-sticky mt-0 ps-4">
        <div class="card-header p-0 pt-4 mb-0 pb-0" style="margin-bottom: 0 !important;">
            <el-dropdown @command="HandleCommand"  placement="bottom-start">
                <button type="button" class="btn mt-0 mb-0 me-2 bg-gradient-success">
                    <span class="btn-text">
                        Yeni əlavə &nbsp;
                        <i class="bi bi-caret-down-fill" style="font-weight:bolder;"></i>
                    </span>
                </button>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item command="1">Digər məlumatların dəyişdirilməsi</el-dropdown-item>
                        <el-dropdown-item command="1">Konvertasiya</el-dropdown-item>
                        <el-dropdown-item command="1">Kredit xəttinin ayrılması</el-dropdown-item>
                        <el-dropdown-item command="1">Ödənişin alınması</el-dropdown-item>
                        <el-dropdown-item command="1">Müqavilə müddətinin dəyişdirilməsi</el-dropdown-item>
                        <el-dropdown-item command="2">Siğorta haqqının dəyişdirilməsi</el-dropdown-item>
                        <el-dropdown-item command="2">Bir aylıq siğorta haqqının dəyişdirilməsi</el-dropdown-item>
                        <el-dropdown-item command="2">Müqavilənin bərpası</el-dropdown-item>
                        <el-dropdown-item command="2">Müqavilənin dondurulması</el-dropdown-item>
                        <el-dropdown-item command="2">Müqaviləyə xitam verilməsi</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
            <button type="button" class="btn mt-0 mb-0" @click="GetLists">
                <span class="btn-text">
                    <i class="fa fa-sync" style="font-weight:bolder;"></i>&nbsp;&nbsp;Yeniləmək</span>
            </button>
            <br />
            <div class="card-body px-0 pt-2 pb-3" v-loading="loading">
                <Table @open-dialog="OpenDialog" @get-data="GetLists" :refindex="this.list.refindex"
                    :constindex="this.list.constindex" :data="data"></Table>
            </div>
        </div>
    </div>
    <el-dialog class="mt-10" :close-on-click-modal="false" v-model="dialogVis" width="25%"
        :title="cmd == 1 ? 'Xitam' : 'Siğorta haqqının dəyişdirilməsi'" modal-class="modal-class"
        :destroy-on-close="true">
        <el-form-item label="Əlavə tarixi" label-position="top">
            <el-date-picker format="DD.MM.YYYY" v-model="values.addDate" class="w-100" type="date"
                placeholder="Pick a day" />
        </el-form-item>
        <el-form-item v-if="cmd == 1" label="Xitam tarixi" label-position="top">
            <el-date-picker format="DD.MM.YYYY" v-model="values.cancelDate" class="w-100" type="date"
                placeholder="Pick a day" />
        </el-form-item>
        <div class="row">
            <div class="col-sm-6">
                <el-form-item v-if="cmd == 2" label="Cari sığorta haqqı" label-position="top">
                    <el-input type="number" v-model="values.currPremium" disabled/>
                </el-form-item>
            </div>
            <div class="col-sm-6">
                <el-form-item v-if="cmd == 2" label="Sığorta haqqı" label-position="top">
                    <el-input type="number" v-model="values.premium" />
                </el-form-item>
            </div>
        </div>
        <div style="background-color: white; display: flex; justify-content: end;">
            <soft-button @click="dialogVis = false" color="success">Daxil et</soft-button>
            &nbsp;&nbsp;&nbsp;
            <soft-button @click="dialogVis = false" color="secondary">Imtina</soft-button>
        </div>
    </el-dialog>
</template>
<script>
import Table from "./Components/Tables/Table.vue";
import SoftButton from "@/components/SoftButton.vue";

export default {
    components: {
        SoftButton,
        Table
    },
    props: {
        priv: Object
    },
    data() {
        return {
            loading: null,
            values: {currPremium: 200, addDate: new Date()},
            dialogVis: false,
            dropdownVisible: false,
            data: [
                {
                    issued: true,
                    addId: 101,
                    addNumber: "Ə-2025/01",
                    addDateStr: "22.08.2025",
                    addCategoryName: "Müqaviləyə xitam verilməsi",
                    addTypeName: "Xitam tarixi - 01.09.2025" 
                },
                {
                    issued: false,
                    addId: 102,
                    addNumber: "Ə-2025/02",
                    addDateStr: "15.08.2025",
                    addCategoryName: "Siğorta haqqının dəyişdirilməsi",
                    addTypeName: "Sığorta haqqı - 150AZN" 
                }
            ],
            cmd: 1,
            list: {
                dialogVis: false,
                object: null,
                refindex: 0,
                constindex: 0
            },
        }
    },
    methods: {
        GetLists() {

            //None
        },
        HandleCommand(cmd) {
            this.cmd = Number(cmd)
            this.dialogVis = true
        },
        NewAdd() {
            window.open(window.location.origin + '/documents/addendum/' + this.$route.path.split("/")[3], "_blank");
        },
    },
    mounted() {
        this.GetLists()
    }
}
</script>